import { request } from '@/shared/api/request'
import { removeFromLocalStorage } from '@/shared'

// Функция для проверки наличия валидных данных в разных форматах
const hasValidData = (data) => {
	if (!data) return false

	// Если это массив
	if (Array.isArray(data)) {
		return data.length > 0
	}

	// Если это объект с массивами
	if (typeof data === 'object') {
		return Object.values(data).some((value) => Array.isArray(value) && value.length > 0)
	}

	return false
}

export const getDictionaries = (dictName, params = {}, path, diffPath) => {
	// Функция для запроса данных с сервера и сохранения в кэш
	async function fetchAndCacheData(dictName, cache, dictVersion) {
		removeFromLocalStorage(dictName)
		const result = await request({
			url: diffPath ? diffPath : (path ? path : '') + 'dict/' + dictName,
			method: 'GET',
			params,
		})
		localStorage.setItem(dictName + '_version', dictVersion.version)

		if (hasValidData(result)) {
			const cacheData = new Response(JSON.stringify(result))
			await cache.put(dictName, cacheData)
		}

		return result
	}

	async function getData(dictName) {
		const dictVersions = JSON.parse(localStorage.getItem('dictVersion'))
		const dictVersion = dictVersions.find((d) => d.code === dictName)
		const localDictVersion = localStorage.getItem(dictName + '_version')
		let result
		if (localDictVersion && +localDictVersion === dictVersion.version) {
			// Проверяем, доступны ли данные в кэше
			if ('caches' in window) {
				const cache = await caches.open('myCache') // Открываем кэш с именем 'myCache'
				const cacheResponse = await cache.match(dictName) // Проверяем наличие данных в кэше
				// Если данные доступны в кэше, возвращаем их
				if (cacheResponse) {
					try {
						// Проверяем статус ответа и наличие контента
						if (!cacheResponse.ok) {
							return await fetchAndCacheData(dictName, cache, dictVersion)
						} else {
							// Получаем текст ответа для проверки
							const responseText = await cacheResponse.text()

							// Проверяем, что есть контент для парсинга
							if (responseText.trim().length === 0) {
								return await fetchAndCacheData(dictName, cache, dictVersion)
							} else {
								// Парсим JSON
								const cacheResult = JSON.parse(responseText)
								// Проверяем, что данные валидны (массив или объект с массивами)
								if (hasValidData(cacheResult)) {
									return cacheResult
								} else {
									return await fetchAndCacheData(dictName, cache, dictVersion)
								}
							}
						}
					} catch (error) {
						return await fetchAndCacheData(dictName, cache, dictVersion)
					}
				} else {
					// Если данные не доступны в кэше, запрашиваем их и записываем
					result = await fetchAndCacheData(dictName, cache, dictVersion)
				}
			}
		} else {
			result = await request({
				url: diffPath ? diffPath : (path ? path : '') + 'dict/' + dictName,
				method: 'GET',
				params,
			})
			localStorage.setItem(dictName + '_version', dictVersion.version)

			// Сохраняем данные в кэше
			if ('caches' in window) {
				const cache = await caches.open('myCache')
				const cacheResponse = await cache.match(dictName) // Проверяем наличие данных в кэше
				if (cacheResponse) {
					// Если данные доступны в кэше, удаляем их
					await caches.delete(dictName)
				}
				const cacheData = new Response(JSON.stringify(result))
				await cache.put(dictName, cacheData)
			}
		}

		return result
	}

	return getData(dictName)
}
